import concat from 'lodash/concat';
import partition from 'lodash/partition';

import type {MeetingFragment as Meeting} from 'nutshell-graphql-types';

import {useGetUsers} from '../../../core/select/hooks';
import {useGetSessionUser} from '../../../core/use-get-session-user';

export type CohostUserOption = {
    value: string;
    label: string;
    avatarUrl: string;
    initials: string;
    isDisabled: boolean;
};

export const useGetCohostUserOptions = (
    meeting?: Meeting | null,
    search?: string | null
): {
    isLoading: boolean;
    cohostUserOptions: CohostUserOption[] | null | undefined;
    preselectedCohostIds: string[];
} => {
    const {users, isLoading: isLoadingUsers} = useGetUsers(search);
    const {user: currentUser, isLoading: isLoadingCurrentUser} = useGetSessionUser();

    let cohostUserOptions;
    if (!isLoadingUsers && currentUser) {
        cohostUserOptions = concat(
            ...partition(
                users.filter((user) => user.isEnabled && user.id !== currentUser.id) || [],
                {
                    calendarSync: {isEnabled: true},
                }
            )
        ).map((user) => ({
            // @ts-expect-error
            label: user.name,
            // @ts-expect-error
            value: user.id,
            // @ts-expect-error
            avatarUrl: user.avatarUrl,
            // @ts-expect-error
            initials: user.initials,
            // @ts-expect-error
            isDisabled: !user.calendarSync || !user.calendarSync.isEnabled,
        }));
    }

    const preselectedCohostIds = [];
    if (meeting) {
        preselectedCohostIds.push(
            ...[meeting.creator, ...meeting.cohosts]
                .filter(
                    (host) =>
                        // host does not have issues
                        !meeting.validity.issues.find((issue) => issue.user.id === host.id) &&
                        // host is not current user
                        currentUser &&
                        currentUser.id !== host.id
                )
                .map((host) => host.id)
        );
    }

    return {
        isLoading: isLoadingUsers || isLoadingCurrentUser,
        cohostUserOptions,
        preselectedCohostIds,
    };
};
